/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpMetadataGet } from "../funcs/mcpMetadataGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetMcpMetadataResponseBody } from "../models/components/getmcpmetadataresponsebody.js";
import {
  GetMcpMetadataRequest,
  GetMcpMetadataSecurity,
} from "../models/operations/getmcpmetadata.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMcpMetadataQueryData = GetMcpMetadataResponseBody;

export function prefetchGetMcpMetadata(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetMcpMetadataRequest | undefined,
  security?: GetMcpMetadataSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMcpMetadataQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMcpMetadataQuery(
  client$: GramCore,
  request?: GetMcpMetadataRequest | undefined,
  security?: GetMcpMetadataSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetMcpMetadataQueryData>;
} {
  return {
    queryKey: queryKeyGetMcpMetadata({
      toolsetSlug: request?.toolsetSlug,
      mcpServerId: request?.mcpServerId,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getMcpMetadataQueryFn(
      ctx,
    ): Promise<GetMcpMetadataQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpMetadataGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMcpMetadata(
  parameters: {
    toolsetSlug?: string | undefined;
    mcpServerId?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpMetadata", "get", parameters];
}
